export default __webpack_public_path__ + "static/media/check-rounded-green.689d36e5.svg";